import 'toastr/build/toastr.min.css';

export const useFocus = () => {
  const setFocus = (
    keybordElement: React.KeyboardEvent<HTMLDivElement | HTMLButtonElement>,
    inputElement: React.MutableRefObject<HTMLInputElement | undefined>,
  ) => {
    if (keybordElement.key === 'Enter') {
      inputElement.current?.focus();
    }
  };
  return { setFocus };
};
